// Header dropdown navigation
export function initNavDropdown() {
  const nav = document.getElementById('site-navigation');
  if (!nav) return;

  const closeAll = () => {
    nav.querySelectorAll('.menu-item-has-children.is-open').forEach((el) => {
      el.classList.remove('is-open');
    });
  };

  nav.addEventListener('click', (e) => {
    const link = e.target.closest('.menu-item-has-children > a');
    if (!link) return;

    e.preventDefault();
    const li = link.closest('li');
    const isOpen = li.classList.contains('is-open');

    closeAll();

    if (!isOpen) {
      li.classList.add('is-open');
    }
  });

  document.addEventListener('click', (e) => {
    if (!nav.contains(e.target)) {
      nav.querySelectorAll('.menu-item-has-children.is-open').forEach((el) => {
        el.classList.remove('is-open');
      });
    }
  });
}

// Header scroll effects using Intersection Observer
export function initHeaderScroll() {
  const header = document.getElementById('site-header');
  
  if (!header) {
    console.error('Header not found!');
    return;
  }

  // Create a sentinel element at the top of the page
  const sentinel = document.createElement('div');
  sentinel.className = 'scroll-sentinel';
  sentinel.style.position = 'absolute';
  sentinel.style.top = '50px';
  sentinel.style.width = '1px';
  sentinel.style.height = '1px';
  sentinel.style.pointerEvents = 'none';
  document.body.appendChild(sentinel);

  // Create Intersection Observer
  const observerOptions = {
    rootMargin: '0px',
    threshold: 0
  };

  const observerCallback = (entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        // Sentinel is out of view (scrolled past 50px)
        header.classList.add('scrolled');
      } else {
        // Sentinel is in view (at top of page)
        header.classList.remove('scrolled');
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);
  observer.observe(sentinel);
}